import Cookies from 'universal-cookie';

export const COOKIE_AGREE = 'privacy-policy-cookie-consent';
export const COOKIE_EXACT_TIME = 'exact-time';
export const COOKIE_USER_ID = 'user-id';
export const COOKIE_SESSION_ID = 'session-id';
export const COOKIE_CONSENT = 'Cookies consent to all at once';

const SECONDS_PER_DAY = 60 * 60 * 24;

export const YEAR_IN_SECONDS = 365 * SECONDS_PER_DAY;
export const COOKIE_AGREE_DEFAULT_TIMEOUT = 150 * SECONDS_PER_DAY;
const cookies = new Cookies();

export interface CookieOption {
  isSecure?: boolean;
  maxAge?: number;
  sameSite?: 'lax' | 'none';
  secure?: boolean;
}

export const setCookies = async (key: string, value: string, options?: CookieOption) => {
  const cookieOptions = {
    path: '/',
    ...options,
  };

  cookies.set(key, value, cookieOptions);

  return value;
};

const generateValue = async (key: string, value = '') => {
  switch (key) {
    case COOKIE_EXACT_TIME:
      return setCookies(key, value);
    case COOKIE_SESSION_ID:
      return setCookies(key, value);
    case COOKIE_USER_ID:
      return setCookies(key, value, { maxAge: YEAR_IN_SECONDS });
    default:
      return '';
  }
};

export const getCookie = (key: string, defaultValue?: string) => {
  const value = cookies.get(key);

  return value || generateValue(key, defaultValue);
};

export const getAnalyticsData = async () => {
  const exactTime = Date.now().toString();

  return {
    userID: await getCookie(COOKIE_USER_ID, exactTime),
    sessionID: await getCookie(COOKIE_SESSION_ID, exactTime),
    exactTime: await generateValue(COOKIE_EXACT_TIME, exactTime),
  };
};

export const removeCookies = async (key: string) => {
  cookies.remove(key, { path: '/' });
};

export const isCookieSet = (key: string): boolean => {
  return !!cookies.get(key);
};
